"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHover = void 0;
var react_1 = require("react");
function useHover() {
    var _a = (0, react_1.useState)(false), value = _a[0], setValue = _a[1];
    var ref = (0, react_1.useRef)(null);
    var handleMouseOver = function () { return setValue(true); };
    var handleMouseOut = function () { return setValue(false); };
    var setRef = (0, react_1.useCallback)(function (node) {
        ref.current = node;
    }, []);
    (0, react_1.useEffect)(function () {
        var node = ref.current;
        if (node) {
            node.addEventListener("mouseover", handleMouseOver);
            node.addEventListener("mouseout", handleMouseOut);
            return function () {
                node.removeEventListener("mouseover", handleMouseOver);
                node.removeEventListener("mouseout", handleMouseOut);
            };
        }
    }, [ref.current]);
    return [setRef, value];
}
exports.useHover = useHover;
